
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/hourly",
      function () {
        return require("private-next-pages/hourly/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/hourly"])
      });
    }
  